module.exports = __webpack_public_path__ + "img/Katarina_home_03.aec775cf.jpg";